export const AUTHENTICATE_EMPLOYEE = 'AUTHENTICATE_EMPLOYEE';
export type AUTHENTICATE_EMPLOYEE = typeof AUTHENTICATE_EMPLOYEE;

export const AUTHENTICATE_EMPLOYEE_FAILED = 'AUTHENTICATE_EMPLOYEE_FAILED';
export type AUTHENTICATE_EMPLOYEE_FAILED = typeof AUTHENTICATE_EMPLOYEE_FAILED;

export const AUTHENTICATE_EMPLOYEE_SUCCESS = 'AUTHENTICATE_EMPLOYEE_SUCCESS';
export type AUTHENTICATE_EMPLOYEE_SUCCESS = typeof AUTHENTICATE_EMPLOYEE_SUCCESS;

export const GET_CURRENT_EMPLOYEE = 'GET_CURRENT_EMPLOYEE';
export type GET_CURRENT_EMPLOYEE = typeof GET_CURRENT_EMPLOYEE;

export const GET_CURRENT_EMPLOYEE_FAILED = 'GET_CURRENT_EMPLOYEE_FAILED';
export type GET_CURRENT_EMPLOYEE_FAILED = typeof GET_CURRENT_EMPLOYEE_FAILED;

export const GET_CURRENT_EMPLOYEE_SUCCESS = 'GET_CURRENT_EMPLOYEE_SUCCESS';
export type GET_CURRENT_EMPLOYEE_SUCCESS = typeof GET_CURRENT_EMPLOYEE_SUCCESS;
